<template>
  <div class="leftNav">
    <el-menu :default-active="activeMenu" class="el-menu-vertical-demo" :collapse="isCollapse" router
             :unique-opened="true"
             text-color="#111111" active-text-color="#1b3b81"
             :collapse-transition="false">
      <div class="header">
        <div style="margin-right: 20px">
          <el-tooltip content="折叠菜单栏" v-if="!isCollapse">
            <i class="el-icon-s-fold foldIcon" @click="changeLeftNav()"></i>
          </el-tooltip>
          <el-tooltip content="展开菜单栏" v-else>
            <i class="el-icon-s-unfold foldIcon" @click="changeLeftNav()"></i>
          </el-tooltip>
        </div>
      </div>
      <sidebar-item v-for="submenu in leftMenus"
                    :key="submenu.path"
                    :submenu="submenu">
      </sidebar-item>
    </el-menu>
  </div>
</template>

<script>

import SidebarItem from "@/components/leftNav/SidebarItem";
import {leftNavData, needRedDoltInfo } from "@/utils/data/basicData/leftNavData";
import {getDataInLocalStorage} from "@/utils/localStorage";

export default {
  name: "LeftNav",
  components: {
    SidebarItem
  },
  data() {
    return {
      isCollapse: false,
      leftMenus: leftNavData,
      role:''
    };
  },
  computed: {
    showLeftMenu() {
      return this.$store.getters['dataStatus/getShowLeftMenu']
    },
    activeMenu() {
      const route = this.$route;
      const {meta, path} = {...route};
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    changeRed(){
      return this.$store.getters['right/getChangeRed']
    }
  },
  created() {
    this.role = getDataInLocalStorage('role')
    this.getRedDotNum()
  },
  watch:{
    '$route'(newVal) {
      this.getRedDotNum()
    },
    changeRed:{
      handler(newVal){
        if(newVal === true){
          this.getRedDotNum()
        }
      },
      immediate:true
    }
  },
  mounted() {

  },
  methods: {
    changeLeftNav() {
      this.isCollapse = !this.isCollapse
    },
    // 获取红点数量
    getRedDotNum() {
      // if(getDataInLocalStorage('EVALUATORS') === 'true' && ['ADMIN','MANAGER','ANALYSE'].includes(this.role)){
      //   needRedDoltInfo.filter(item => item.role.includes(this.role) || item.role.includes('EVALUATORS')).forEach(item => {
      //     this.$store.dispatch(`dataStatus/getRedDoltNum`, item)
      //   })
      // }else{
        needRedDoltInfo.filter(item => item.role.includes(this.role)).forEach(item => {
          this.$store.dispatch(`dataStatus/getRedDoltNum`, item)
        })
      // }
      this.$store.commit('right/setChangeRed',false)
    },
  }
}
</script>

<style  scoped>
.header {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  padding-top: 20px;
  margin-bottom:10px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 210px;
  height: calc(100vh - 60px);
  background-color: white;
}
:deep(.el-menu--collapse .el-submenu .el-submenu__title span){
  visibility: hidden!important;
}
.foldIcon {
  font-size: 23px;
  color: #b4b5b6;
  cursor: pointer;
}

</style>
